import { Accordion } from '@liveauctioneers/hammer-ui-core/accordion';
import { getMessagesUrl, getMyBidsUrl, getWonItemsPageUrl } from '@/utils/urls';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import FormattedMessageText from '@/components/Formatted/FormattedMessageText';
import React from 'react';
import styled from 'styled-components';

type QAProps = {
    id: string;
};

const QA = ({ id }: QAProps) => {
    const { formatMessage } = useIntl();

    return (
        <QuestionContainer data-testid="FAQQuestionsList">
            <Accordion
                className="w-full border-b border-t-0 border-border-primary"
                density="compact"
                emphasis="subtle"
                headline={formatMessage({ id: `question_${id}_question` })}
                open={false}
            >
                <Answer>
                    <FormattedMessageText
                        id={`question_${id}_answer`}
                        values={{
                            learnMore: (...msg) => (
                                <Link
                                    className="!no-underline"
                                    href="https://help.liveauctioneers.com/category/12-bidding-ins-outs-in-betweens"
                                    key="how-auctions-work-learn-more-link"
                                    size="sm"
                                >
                                    {msg}
                                </Link>
                            ),
                            messages: (...msg) => (
                                <Link
                                    className="!no-underline"
                                    href={getMessagesUrl()}
                                    key="how-auctions-work-messages-link"
                                    size="sm"
                                >
                                    {msg}
                                </Link>
                            ),
                            myBids: (...msg) => (
                                <Link
                                    className="!no-underline"
                                    href={getMyBidsUrl()}
                                    key="how-auctions-work-my-bids-link"
                                    size="sm"
                                >
                                    {msg}
                                </Link>
                            ),
                            wonItems: (...msg) => (
                                <Link
                                    className="!no-underline"
                                    href={getWonItemsPageUrl()}
                                    key="how-auctions-work-won-items-link"
                                    size="sm"
                                >
                                    {msg}
                                </Link>
                            ),
                        }}
                    />
                </Answer>
            </Accordion>
        </QuestionContainer>
    );
};

export default QA;

const QuestionContainer = styled.div`
    max-width: ${({ theme }) => theme.breakpoints.pageWidth};
    margin: 0 auto;
    width: 100%;
`;

const Answer = styled.div`
    padding: 12px 30px 11px 30px;
    margin-bottom: 7px;
`;
